import { InfoIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { DimeButton } from './DimeButton.js';
import { DimeTooltip } from './DimeTooltip.js';

type DimeInfoHintProps = Readonly<
  {
    /** `icon-xs` is a 24px target for a hint a phone user has to tap. */
    size?: 'default' | 'icon-xs';
    variant?: 'default' | 'card';
  } & ({ content: string; label?: string } | { content: ReactNode; label: string })
>;

/** A focusable info icon whose tooltip text is also its accessible name unless `label` names it. */
export function DimeInfoHint({ content, label, size = 'default', variant }: DimeInfoHintProps) {
  const accessibleName = label ?? (content as string);
  return (
    <DimeTooltip content={content} variant={variant} openOnTap>
      {size === 'icon-xs' ? (
        <DimeButton
          type="button"
          variant="ghost"
          size="icon-xs"
          aria-label={accessibleName}
          className="text-muted-foreground"
        >
          <InfoIcon aria-hidden="true" className="size-3.5" />
        </DimeButton>
      ) : (
        <button
          type="button"
          aria-label={accessibleName}
          className="rounded-sm text-muted-foreground hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
        >
          <InfoIcon className="size-3.5" aria-hidden="true" />
        </button>
      )}
    </DimeTooltip>
  );
}
